export default "__VITE_ASSET__CqXtaOpj__"